import { TabIconProp } from '../../utils/types';
import { StyleSheet, View } from 'react-native';
import React from 'react';

const AgendaIcon = ({ focused }: TabIconProp) => {
  return (
    <View style={styles.img}>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1221_2271)">
          <path
            d="M28 14.0112C27.9888 21.8176 21.7056 28.056 13.8432 28C6.16 27.944 0 21.7168 0 14.0112C0 6.23841 6.2832 -0.011185 14.056 1.50302e-05C21.7392 0.011215 28.0112 6.31682 28 14.0112ZM7.9184 11.5248C7.7056 11.5248 7.504 11.5136 7.3024 11.5248C6.8208 11.5584 6.5072 11.9056 6.5184 12.3648C6.5296 12.8128 6.8656 13.1152 7.3472 13.1376C7.5376 13.1376 7.728 13.1376 7.9072 13.1376V14.8624C7.7168 14.8624 7.5488 14.8624 7.392 14.8624C6.8768 14.8624 6.5296 15.176 6.5184 15.6464C6.5072 16.128 6.8432 16.464 7.3696 16.4864C7.5488 16.4864 7.728 16.4864 7.9184 16.4864V18.2C7.728 18.2 7.56 18.2 7.3808 18.2C6.8768 18.2 6.5184 18.5248 6.5184 18.984C6.5184 19.4656 6.8544 19.8016 7.3696 19.824C7.5488 19.824 7.728 19.824 7.9296 19.824C7.9296 20.3728 7.9296 20.888 7.9296 21.4032C7.9296 22.0976 8.232 22.4 8.9264 22.4C12.4208 22.4 15.904 22.4 19.3984 22.4C20.0928 22.4 20.3952 22.0976 20.3952 21.4144C20.3952 20.272 20.3952 19.1184 20.3952 17.976V17.6736C19.6224 17.6736 18.8944 17.6736 18.1664 17.6736C16.5984 17.6512 15.2096 16.6208 14.728 15.12C14.2464 13.6192 14.784 11.984 16.0608 11.0432C16.7104 10.5728 17.4384 10.3376 18.2448 10.3376C18.9504 10.3376 19.656 10.3376 20.384 10.3376C20.384 10.2144 20.3952 10.1248 20.3952 10.024C20.3952 8.88162 20.3952 7.75041 20.3952 6.60801C20.3952 5.90241 20.0928 5.60001 19.376 5.60001C15.8928 5.60001 12.4096 5.60001 8.9376 5.60001C8.2208 5.60001 7.9296 5.89121 7.9296 6.60801C7.9296 7.12321 7.9296 7.63842 7.9296 8.17602C7.6944 8.17602 7.4928 8.16482 7.2912 8.17602C6.8208 8.20962 6.496 8.56802 6.5072 9.01602C6.5184 9.45282 6.8656 9.77762 7.3248 9.78882C7.5152 9.78882 7.7056 9.78882 7.9072 9.78882V11.5136L7.9184 11.5248ZM21.4816 14.0336C21.4816 13.3728 21.4816 12.712 21.4816 12.0512C21.4816 11.4576 21.168 11.144 20.5856 11.144C19.8128 11.144 19.0288 11.144 18.256 11.144C16.6544 11.1552 15.4 12.4096 15.3888 13.9888C15.3888 15.5792 16.6432 16.8448 18.256 16.856C19.0288 16.856 19.8128 16.856 20.5856 16.856C21.168 16.856 21.4816 16.5424 21.4816 15.9488C21.4816 15.3104 21.4816 14.672 21.4816 14.0224V14.0336Z"
            fill={focused ? 'url(#paint0_linear_1221_2271)' : '#AFAFAF'}
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1221_2271"
            x1="0"
            y1="14"
            x2="28"
            y2="14"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C0A415" />
            <stop offset="1" stopColor="#D4C100" />
          </linearGradient>
          <clipPath id="clip0_1221_2271">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </View>
  );
};
const styles = StyleSheet.create({
  img: {
    width: 36,
    height: 80,
    alignItems: 'center',
  },
});

export default AgendaIcon;
